import { createIllustration } from '@jira/illustrations__illustration/src/ui/index.tsx';
import type {
	AsImgProps,
	IllustrationFn,
} from '@jira/illustrations__illustration/src/ui/types.tsx';
import srcDark from '../../assets/admin-permission-lock-darkmode.svg';
import srcLight from '../../assets/admin-permission-lock.svg';

const AdminPermissionLockIllustration: IllustrationFn<AsImgProps> = createIllustration({
	srcLight,
	srcDark,
});

export default AdminPermissionLockIllustration;
